import { useCallback } from "react"
import { batch } from "react-redux"
import { useAppDispatch } from "@/core/root-reducer"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import { Unit } from "@/features/risks/entities/unit/model/unit.types"

type Result = {
  confirmDelete: () => Promise<void>
}

export function useUnitEditModal(units: Unit[], activeUnit: Unit | null): Result {
  const dispatch = useAppDispatch()

  const confirmDelete = useCallback(async () => {
    if (!activeUnit) return

    const snapshot: Unit[] = units.map((u) => ({ ...u }))

    batch(() => {
      dispatch(unitStore.actions.setActive(null))
    })

    try {
      await dispatch(unitStore.thunks.removeEntity(activeUnit.id)).unwrap()
    } catch (error) {
      console.error("❌ Failed to delete unit tree (server). Rolling back).", error)
      dispatch(unitStore.actions.setList(snapshot))
    }
  }, [activeUnit, units, dispatch])

  return { confirmDelete }
}
